var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2498 6.33317H13.4582V4.74984C13.4582 2.56484 11.6848 0.791504 9.49984 0.791504C7.31484 0.791504 5.5415 2.56484 5.5415 4.74984V6.33317H4.74984C3.879 6.33317 3.1665 7.04567 3.1665 7.9165V15.8332C3.1665 16.704 3.879 17.4165 4.74984 17.4165H14.2498C15.1207 17.4165 15.8332 16.704 15.8332 15.8332V7.9165C15.8332 7.04567 15.1207 6.33317 14.2498 6.33317ZM9.49984 13.4582C8.629 13.4582 7.9165 12.7457 7.9165 11.8748C7.9165 11.004 8.629 10.2915 9.49984 10.2915C10.3707 10.2915 11.0832 11.004 11.0832 11.8748C11.0832 12.7457 10.3707 13.4582 9.49984 13.4582ZM11.954 6.33317H7.04567V4.74984C7.04567 3.39609 8.14609 2.29567 9.49984 2.29567C10.8536 2.29567 11.954 3.39609 11.954 4.74984V6.33317Z",
    fill: "#FDFDFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.153915351307e42357282b3a92da1c26.svg";
export { ForwardRef as ReactComponent };